<template>
    <div>
        <template v-if="data.orderId">
            <span v-if="data.clientReference" ref="trigger">{{ data.clientReference }}</span>
            <span v-if="!data.clientReference" ref="trigger">-- not stated --</span>
            <b-popover :target="popoverTarget" triggers="hover" @show="onPopoverShow">
                <b-skeleton-wrapper :loading="!orderSittings">
                    <template #loading>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                    </template>
                    <b-list-group>
                        <b-list-group-item v-for="(orderSitting) in orderSittings" :key="orderSitting.order.orderId">
                            <div>{{ orderSitting.sitting.sittingDayDateDisplayText }} </div>
                            <div v-if="orderSitting.clientReference">Client ref: {{ orderSitting.clientReference }}</div>
                            <div v-if="!orderSitting.clientReference">Client ref: -- not stated --</div>
                        </b-list-group-item>
                    </b-list-group>
                </b-skeleton-wrapper>
            </b-popover>
        </template>
    </div>
</template>

<script>
    import axios from 'axios';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import ErrorsMixin from '../../mixins/ErrorsMixin';

    export default {
        name: 'RelatedSittingsClientReferenceColumnTemplate',
        mixins: [ErrorsMixin, DateTimeMixin],
        data: function () {
            return {
                data: null,
                orderSittings: null,
            };
        },

        methods: {
            popoverTarget: function () {
                return this.$refs.trigger;
            },
            onPopoverShow: function () {
                if (this.orderSittings === null) {
                    this.loadOrderSittings();
                }
            },
            loadOrderSittings: function () {
                var url = this.$urlHelper.getApiUrl('courtsitting', 'byorder', [this.data.orderId, 'list']);
                axios
                    .get(url)
                    .then(response => {
                        this.orderSittings = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            }
        }
    }
</script>